import { Model } from "@/models/base/model";

export class SurveyForm extends Model {
  constructor(params: any = {}) {
    super(params);
  }

  // アンケート一覧取得
  async getSurveys(diseaseCode: string): Promise<any> {
    this.url = `/cms/health-care/surveys/${diseaseCode}`;
    return await super.fetch();
  }
}
